import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import ThemeCardItems from './ThemeCardItems';

const ThemeCards = ({
  category,
  handleScroll,
  items,
  itemsPerRow,
  readErrors,
  readStatus,
}) => (
  <InfiniteScrollCards
    className="aridhia-theme-cards"
    entity="theme"
    handleScroll={handleScroll}
    icon="paint brush"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
  >
    <ThemeCardItems items={items} category={category} />
  </InfiniteScrollCards>
);

export default ThemeCards;
